module.exports = __webpack_public_path__ + "static/media/sutd_logo.0df33366.png";